exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".book-session-with-career-buddy-calendar {\n  background-color: #FFFFFF;\n  padding: 0rem 2rem;\n}\n@media only screen and (max-width: 47.938rem) {\n  .book-session-with-career-buddy-calendar {\n    padding: 1rem 0.5rem;\n  }\n}\n", ""]);

